import React from 'react'

import { AsyncSelect, Form, Col, Button } from '_zari/core'

import { NuevoClienteModal } from 'sharedComponents/modals'

import { AdminContext } from 'contexts/AdminContext'
import TipoDeBusquedaSociosConstant from 'constants/tiposDeBusquedaDeSocios'
import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ fIsSubmitting, iValue, values, setValues }) => {
  const __adminContext = React.useContext(AdminContext)

  const [mostrarNuevoSocioModal, setMostrarNuevoSocioModal] = React.useState(false)

  const loadSociosSelect = (inputValue, resolve) => {
    SocioCrud.obtenerClientesxBusquedaAsSelect2({
      busqueda: inputValue,
      tipoSalida: 'codigo-ruc'
    }).then(({ data }) => resolve(data))
  }

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
    })
  }

  const clickMostrarNuevoSocioModalHandler = e => {
    e.preventDefault()
    setMostrarNuevoSocioModal(true)
  }

  const seleccionarSocioCreadoHandler = socioCreado => {
    setMostrarNuevoSocioModal(false)
    values._idSocio = socioCreado._id
    values.nombreSocio = socioCreado.razonSocial
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.tipoDocumentoSocio = socioCreado.tipoDocumento

    setValues(values)
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='RUC' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <Form.InputText
              disabled
              id='input-codigoRucSocio'
              defaultValue={
                __adminContext.valoresConfiguracionCompania.tipoBusquedaSocios === TipoDeBusquedaSociosConstant.CODIGO
                  ? values.codigoSocio
                  : values.documentoSocio
              }
            />
          ) : (
            <Form.InputGroup>
              <AsyncSelect selectId='codigoRucSelect' loadOptions={loadSociosSelect} onChange={onChangeSocioHandler} />
              <Form.InputGroup.Append>
                <Button disabled={fIsSubmitting} onClick={clickMostrarNuevoSocioModalHandler}>
                  &#x2b;
                </Button>
              </Form.InputGroup.Append>
            </Form.InputGroup>
          )}
        </Col>
      </Form.Group>
      {mostrarNuevoSocioModal && (
        <NuevoClienteModal
          handleClose={e => setMostrarNuevoSocioModal(false)}
          show={mostrarNuevoSocioModal}
          onCreate={seleccionarSocioCreadoHandler}
        />
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
